import React from 'react';
import { Link, navigate } from 'gatsby';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { List, Search, HouseFill, Newspaper, InfoCircleFill, EnvelopeFill, CircleHalf } from 'react-bootstrap-icons';

import { ThemeContext } from '../../context/themecontext';

import './menu.css';

const MainMenu = (props) => {
	const userTheme = React.useContext(ThemeContext);

	const [menuOpen, setMenuOpen] = React.useState(false);
	const [query, setQuery] = React.useState('');

	const handleSearchSubmit = (form, event) => {
		event.preventDefault();
		event.stopPropagation();
		if (query !== '') navigate(`/search/?q=${encodeURI(query)}`);
	};

	const handleLinkClick = () => {
		setMenuOpen(false);
	};

	/* autoFocus on search control gives accessibility warning */
	return (
		<React.Fragment>
			<Link to='/search/' onClick={(e) => triggerMenu(e)}>
				<List className='actionicon' size='24' />
			</Link>
			<Modal size='lg'
				show={menuOpen}
				onHide={() => setMenuOpen(false)}
				className='menu'
			>
				<Modal.Body>
					<Form style={{ marginBottom: '1em' }} onSubmit={(e) => handleSearchSubmit(e.currentTarget, e)}>
						<div style={{ display: 'flex', gap: '.5em', alignItems: 'center' }}>
							<div style={{ flexGrow: '1' }}>
								<Form.Control
									type='text'
									placeholder='Search the archives'
									onChange={({ target }) => setQuery(target.value)}
								/>
							</div>
							<div>
								<Button size='sm' className='standard' onClick={(e) => handleSearchSubmit(e.currentTarget.parentElement, e)}>
									<div style={{ display: 'flex', alignItems: 'center', padding: '3px 0' }}>
										<Search />
									</div>
								</Button>
							</div>
						</div>
					</Form>
					<div className='flexRow'>
						<div className='sectionMap'>
							<b><Link to='/books/'>A Song of Ice and Fire</Link></b>
							<ol>
								<li><Link to='/books/101/'>A Game of Thrones</Link></li>
								<li><Link to='/books/102/'>A Clash of Kings</Link></li>
								<li><Link to='/books/103/'>A Storm of Swords</Link></li>
								<li><Link to='/books/104/'>A Feast for Crows</Link></li>
								<li><Link to='/books/105/'>A Dance with Dragons</Link></li>
							</ol>
						</div>
						<div className='sectionMap'>
							<b><Link to='/gameofthrones/'>Game of Thrones</Link></b>
							<ol>
								<li><Link to='/gameofthrones/1/'>Season 1 (2011)</Link></li>
								<li><Link to='/gameofthrones/2/'>Season 2 (2012)</Link></li>
								<li><Link to='/gameofthrones/3/'>Season 3 (2013)</Link></li>
								<li><Link to='/gameofthrones/4/'>Season 4 (2014)</Link></li>
								<li><Link to='/gameofthrones/5/'>Season 5 (2015)</Link></li>
								<li><Link to='/gameofthrones/6/'>Season 6 (2016)</Link></li>
								<li><Link to='/gameofthrones/7/'>Season 7 (2017)</Link></li>
								<li><Link to='/gameofthrones/8/'>Season 8 (2019)</Link></li>
							</ol>
						</div>
						<div className='sectionMap'>
							<b><Link to='/houseofthedragon/'>House of the Dragon</Link></b>
							<ol>
								<li><Link to='/houseofthedragon/1/'>Season 1 (2022)</Link></li>
								<li><Link to='/houseofthedragon/2/'>Season 2 (2024)</Link></li>
							</ol>
						</div>
					</div>
					<div className='flexRow'>
						<div><Link to='/'><HouseFill size='20' style={{ verticalAlign: 'text-top' }} /> <b>Home</b></Link></div>
						<div><Link to='/blog/'><Newspaper size='20' style={{ verticalAlign: 'text-top' }} /> <b>Archives</b></Link></div>
						<div><Link to='/about/'><InfoCircleFill size='20' style={{ verticalAlign: 'text-top' }} /> <b>About</b></Link></div>
						<div><Link to='/contact/'><EnvelopeFill size='20' style={{ verticalAlign: 'text-top' }} /> <b>Contact Us</b></Link></div>
					</div>
					<div style={{ textAlign: 'center' }}>
						<Button variant='link' className='themeToggle'
							onClick={() => { userTheme.setPreference(userTheme.theme === 'light' ? 'dark' : 'light'); handleLinkClick(); }}
						>
							<CircleHalf size='18' style={{ verticalAlign: 'text-bottom' }} /> Toggle Theme
						</Button>
					</div>
				</Modal.Body>
			</Modal>
		</React.Fragment>
	);

	function triggerMenu(e) {
		setMenuOpen(true);
		e.stopPropagation();
		e.preventDefault();
		return false;
	}
}

export default MainMenu;
